export default "__VITE_ASSET__DUBP2ctu__"